/**
 * @file Payload SDK client with typed configuration for the Mosaic project.
 */ import { PayloadSDK as CorePayloadSDK } from "@payloadcms/sdk";
/**
 * Payload SDK configured with the Mosaic project's Payload configuration.
 *
 * @see {@link https://payloadcms.com/docs/rest-api/overview#payload-rest-api-sdk}
 */ export class PayloadSDK extends CorePayloadSDK {
}

//# sourceMappingURL=sdk.js.map